/**
 * Function to get the indexes of the highlighted and selected checkpoints
 * @param checkpoints
 * @param highlightedCheckpointID
 * @returns {highlightedCheckpointIndex , selectedCheckpointIndexes}
 */
export function getCheckPointIndexes(
	checkpoints: Checkpoint[],
	highlightedCheckpointID: number,
) {
	let highlightedCheckpointIndex: number = -1;
	const selectedCheckpointIndexes: number[] = [];

	checkpoints.forEach((checkpoint, index) => {
		if (checkpoint.CheckpointID === highlightedCheckpointID) {
			highlightedCheckpointIndex = index;
		}
		if (checkpoint.isSelected) {
			selectedCheckpointIndexes.push(index);
		}
	});

	return { highlightedCheckpointIndex, selectedCheckpointIndexes };
}
